import { Injectable } from '@angular/core';
import { Subpoena } from '../models/subpoena.model';
import { Ipat } from '../models/ipat.models';
import { IpatSteps } from '../models/ipat-steps.models';
import { Constants } from '../settings/constants';
import { BehaviorSubject } from 'rxjs';
import { PeripheralBridgeService } from '../utils/peripheral-bridge.service';

@Injectable({
  providedIn: 'root',
})
export class DataService {
  private ipatStepsChanged = new BehaviorSubject<void>(undefined);
  ipatStepsChanged$ = this.ipatStepsChanged.asObservable();

  private saveLastLocationSubject = new BehaviorSubject<boolean>(false);
  saveLastLocation$ = this.saveLastLocationSubject.asObservable();

  constructor(private peripheralBridgeService: PeripheralBridgeService) {
    const flow_infraction = this.getData(Constants.CODE_FLOW_INFRACTION);
    const flow_infraction_service = this.getData(
      Constants.CODE_FLOW_INFRACTION_SERVICE
    );
    const flow_ipat = this.getData(Constants.CODE_FLOW_IPAT);
    const ipat_steps = this.getData(Constants.IPAT_STEPS);
    const defaultSubpoena: Subpoena = this.getDefaultSubpoena();
    const defaultIpat: Ipat = this.getDefaultIpat();
    const defaultIpatSteps: IpatSteps = this.getDefaultIpatSeps();

    if (!flow_infraction) {
      this.saveData(Constants.CODE_FLOW_INFRACTION, defaultSubpoena);
    }

    if (!flow_infraction_service) {
      this.saveData(Constants.CODE_FLOW_INFRACTION_SERVICE, defaultSubpoena);
    }

    if (!flow_ipat) {
      this.saveData(Constants.CODE_FLOW_IPAT, defaultIpat);
    } 

    if (!ipat_steps) {
      this.saveData(Constants.IPAT_STEPS, defaultIpatSteps);
    }
  }

  emitIpatStepsChange() {
    this.ipatStepsChanged.next();
  }

  saveData(repo: string, data: any): void {
    this.peripheralBridgeService.saveData(repo, data);
  }

  getData(repo: string): any {
    const data = this.peripheralBridgeService.getData(repo);
    return data !== undefined && data !== null && data !== 'undefined'
      ? JSON.parse(data)
      : null;
  }

  deleteData(repo: string): void {
    this.peripheralBridgeService.deleteData(repo);
  }

  getDefaultSubpoena(): Subpoena {
    return {
      secretary: '',
      municipality: '',
      logo: '/storage/emulated/0/Pictures/SISDRINFA/logo.png',
      idInfractionNumber: '',
      idInfractionNumberLabel: '',
      infraction_data: {
        date_time: '',
        code: '',
        amount_to_pay: '',
        reason: '',
        infringement: 0, // Comentado porque no se usa en el modelo actual,
        numSmdlv: 0,
      },
      location: {
        idOffenderType: '',
        idDepartment: '',
        idCity: '',
        idDivipo: '',
        applyIncidentDate: false,
        incidentDateTime: null,
        address: '',
        longitude: 0,
        latitude: 0,
        location: '',
      },
      vehicle: {
        vehicleWithoutPlate: false,
        foreignVehicle: false,
        idCountryOrigin: '',
        countryOriginName: '',
        plate: '',
        idOrganization: '',
        nameOrganization: '',
        idVehicleType: '',
        idClassServices: '',
        actionRadio: '',
        actionRadioName: '',
        modality: '',
        modalityName: '',
        color:'',
        fuelTypeId: '',
        fuelTypeName: '',
        cantPassengers: '',
        charge: '',
        chargeName: '',
        passengers: '',
        personData: {
          firstName1: '',
          firstName2: '',
          documentType: '',
          document: '',
          categorias: '',
          lastName1: '',
          lastName2: '',
          address: '',
        },
        runtData: {
          soat: {
            status: false,
            number: '',
            expeditionDate: '',
            finalDate: '',
            isMissingDocument: false,
          },
          rtm: {
            status: false,
            require: false,
            number: '',
            reviewDate: '',
            finalDate: '',
            isMissingDocument: false,
          },
          license: {
            number: '',
            brand: '',
            model: '',
            motorNumber: '',
            serialNumber: '',
            isMissingDocument: false,
            registerDate: '',

          },
        },
      },
      property: {
        idDocumentType: '',
        document: '',
        firstName: '',
        secoundName: '',
        lastName: '',
        scoundLastName: '',
        idDepartment: 0,
        idCity: 0,
        address: '',
        phone: '',
        email: '',
        birthDate: '',
        isPerson: false,
        gender: ''
      },
      company: {
        nit: '',
        businessName: '',
        applyPerson: false,
        idDepartment: '',
        idCity: '',
        address: '',
        phone: '',
        email: '',
        operationCardData: {
          status: false,
          operationCardNumber: '',
          licensePlateNumber: '',
          proprietary: '',
          company: '',
          modalityService: '',
          modality: '',
          operationBase: '',
          actionRadioOp: '',
          trafficagency: '',
          expeditionDate: '',
          finalDate: '',
          vehicleType: '',
          brand: '',
          modelYear: 0,
          chassisNumber: '',
          engineNumber: '',
          passengerCapacity: 0,
          fuelType: '',
          nit: '',
          companyNumber: 0,
          driverName: '',
          secondDriverName: '',
        },
      },
      companyTransport: {
        nit: '',
        businessName: '',
        applyPerson: false,
        idDepartment: '',
        idCity: '',
        address: '',
        phone: '',
        email: '',
        isPropertyCompany: false,
        operationCardData: {
          status: false,
          operationCardNumber: '',
          licensePlateNumber: '',
          proprietary: '',
          company: '',
          modalityService: '',
          modality: '',
          operationBase: '',
          actionRadioOp: '',
          trafficagency: '',
          expeditionDate: '',
          finalDate: '',
          vehicleType: '',
          brand: '',
          modelYear: 0,
          chassisNumber: '',
          engineNumber: '',
          passengerCapacity: 0,
          fuelType: '',
          nit: '',
          companyNumber: 0,
          driverName: '',
          secondDriverName: '',
        },
      },

      offender: {
        offenderNotDocument: false,
        refusedToIdentify: false,
        offenderNotIdentified: false,
        isProperty: false,
        idDocumentType: '',
        document: '',
        firstName: '',
        secoundName: '',
        lastName: '',
        scoundLastName: '',
        idDepartment: '',
        idCity: '',
        address: '',
        phone: '',
        email: '',
        birthdate: '',
        gender: ''
      },
      licenseOffender: {
        idCountry: '',
        idCategory: '',
        expeditionDate: null,
        expirationDate: null,
        isMissingDocument: false,
        number: '',
        status: '',
      },
      observations: {
        immobilization: false,
        drain: false,
        accident: false,
        notImmobilization: false,
        reason: '',
        numInv: '',
        quad: '',
        hoist: '',
        applyBaodez: false,
        refusal: false,
        idDevice: '',
        result: '',
        firstRev: '',
        secondRev: '',
        correctedResult: '',
        grade: '',
        yardName: '',
        craneName: '',
        observation: '',
      },
      witness: {
        idDocumentType: '',
        document: '',
        firstName: '',
        secoundName: '',
        lastName: '',
        scoundLastName: '',
        idDepartment: '',
        idCity: '',
        address: '',
        phone: '',
        email: '',
      },
      signatureOffender: { type: "", idInfractionNumber: "", signature: "", isBase64: false , refusedToSign: false, offenderAbsent: false, offenderNotIdentified: false},
      signatureWitness: { type: "", idInfractionNumber: "", signature: "", isBase64: false },
      agentData: {
        idPolice: '',
        name: '',
        badgeNumber: '',
        signatureAgent: {
          type: '',
          idInfractionNumber: '',
          signature: '',
          isBase64: false,
        },
      },
      legalNotes: '/storage/emulated/0/Pictures/SISDRINFA/legalNotes.png',
      sync: false,
      syncError: false,
      routePdfS3: '',
    };
  }

   getDefaultIpat(): Ipat {
    return {
      driver: {
        idDocumentType: '',
        document: '',
        firstName: '',
        secoundName: '',
        lastName: '',
        scoundLastName: '',
        idDepartment: '',
        idCity: '',
        address: '',
        phone: '',
        email: '',
        isProperty: false,
      },
      vehicle: {
        plate: '',
        idOrganization: '',
        idVehicleType: '',
        idClassServices: '',
        actionRadio: '',
        actionRadioName: '',
        modality: '',
        modalityName: '',
        charge: '',
        chargeName: '',
        passengers: '',
        personData: {
          firstName1: '',
          firstName2: '',
          documentType: '',
          document: '',
          categorias: '',
          lastName1: '',
          lastName2: '',
          address: '',
        },
        runtData: {
          soat: {
            status: false,
            number: '',
            expeditionDate: '',
            startDate: '',
            finalDate: '',
            isMissingDocument: false,
          },
          rtm: {
            status: false,
            require: false,
            number: '',
            reviewDate: '',
            finalDate: '',
            isMissingDocument: false,
          },
          license: {
            number: '',
            brand: '',
            model: '',
            motorNumber: '',
            serialNumber: '',
            isMissingDocument: false,
            registerDate: '',
          },
        },
      },
      property: {
        idDocumentType: '',
        document: '',
        firstName: '',
        secoundName: '',
        lastName: '',
        scoundLastName: '',
        idDepartment: '',
        idCity: '',
        address: '',
        phone: '',
        email: '',
        birthDate: '',
      },
      victims: {
        idDocumentType: '',
        document: '',
        firstName: '',
        secoundName: '',
        lastName: '',
        scoundLastName: '',
        idDepartment: '',
        idCity: '',
        address: '',
        phone: '',
        email: '',
      },
      witness: {
        idDocumentType: '',
        document: '',
        firstName: '',
        secoundName: '',
        lastName: '',
        scoundLastName: '',
        idDepartment: '',
        idCity: '',
        address: '',
        phone: '',
        email: '',
      },
      stepData: {
        trafficAuthority: [],
        accidentType: [],
        locationCharacteristics: [],
        roadwayCharacteristics: [],
        driversVehiclesOwners: [],
        victimsPassengersOccupantsPedestrians: [],
        accidentHypothesis:[],
        infoWitness: [],
        observationsIpat: [],
        involvedOfficers: [],
        topographicSketch: [],
        evidence: [],
      }
    };
  } 

  getDefaultIpatSeps(): IpatSteps {
    return {
      step1: {
        name: 'Organismo de Tránsito',
        data: [],
        completed: false,
      },
      step2: {
        name: 'Clase de Accidente',
        data: [],
        completed: false,
      },
      step3: {
        name: 'Características del Lugar',
        data: [],
        completed: false,
      },
      step4: {
        name: 'Características de las Vías',
        data: [],
        completed: false,
      },
      step5: {
        name: 'Conductores, Vehículos y Propietarios',
        data: [],
        completed: false,
      },
      step6: {
        name: 'Victimas: Pasajeros, Acompañantes o Peatones',
        data: [],
        completed: false,
      },
      step7: {
        name: 'Hipótesis del Accidente',
        data: [],
        completed: false,
      },
      step8: {
        name: 'Testigos',
        data: [],
        completed: false,
      },
      step9: {
        name: 'Observaciones Ipat',
        data: [],
        completed: false,
      },
      step10: {
        name: 'Agentes Involucrados',
        data: [],
        completed: false,
      },
      step11: {
        name: 'Croquis: Bosquejo Topográfico',
        data: [],
        completed: false,
      },
      step12: {
        name: 'Evidencia',
        data: [],
        completed: false,
      },
    };
  }

  validarSteps(data: IpatSteps) {
    for (const stepKey in data) {
      const step = data[stepKey];
      const isComplete = step.data.every((item) =>
        Object.values(item).every(
          (value) => value !== null && value !== '' && value !== undefined
        )
      );
      step.completed = isComplete;
    }
    return data;
  }

  saveIpat(ipat: Ipat): void {
    this.saveData(
      Constants.CODE_FLOW_IPAT,
      ipat
    );
  }

  // Actualiza el valor del booleano
  setSaveLastLocation(value: boolean) {
    this.saveLastLocationSubject.next(value);
  }

  // Obtiene el valor actual
  getSaveLastLocation(): boolean {
    return this.saveLastLocationSubject.value;
  }

}
